import { Permission } from '@cims-online/shared'
import CimsQuickLinkEntityTable from 'components/CIMSTable/common/components/CimsQuickLinkEntityTable'
import {
  useCreateRfiQuickLinkMutation,
  useEditRfiQuickLinkMutation,
  useGetRfiQuickLinksQuery,
  useRestoreRfiQuickLinkMutation,
  useSoftRemoveRfiQuickLinkMutation,
} from 'schema'

const RFIQuickLinks: React.FC = () => (
  <CimsQuickLinkEntityTable
    query={useGetRfiQuickLinksQuery}
    entity="Request For Information"
    getQuickLinks={(data) => data?.rfiQuickLinks?.records ?? []}
    create={{
      permission: Permission.CreateRFIQuickLink,
      mutation: useCreateRfiQuickLinkMutation,
      getLabel: ({ createRFIQuickLink: create }) => create.rfiQuickLink,
    }}
    edit={{
      permission: Permission.EditRFIQuickLink,
      mutation: useEditRfiQuickLinkMutation,
      getLabel: ({ editRFIQuickLink: edit }) => edit.rfiQuickLink,
    }}
    remove={{
      permission: Permission.RemoveRestoreRFIQuickLink,
      mutation: useSoftRemoveRfiQuickLinkMutation,
      getLabel: ({ softRemoveRFIQuickLink: remove }) => remove.rfiQuickLink,
    }}
    restore={{
      permission: Permission.RemoveRestoreRFIQuickLink,
      mutation: useRestoreRfiQuickLinkMutation,
      getLabel: ({ restoreRFIQuickLink: restore }) => restore.rfiQuickLink,
    }}
  />
)

export default RFIQuickLinks
